/**
 * Constant in the sharedModule. It lists all available languages in softwear,
 * with the first one being the default one.
 * Language names are stored in their respective language. Example:
 * <code><pre>
 * [{
 *   code: 'nl-nl',
 *   name: 'Nederlands'
 * }]
 * </pre></code>
 */
export interface ILanguageName {
  code: string;
  name: string;
}

export type LanguageNames = ILanguageName[];

let languageNames: LanguageNames = [
  {
    code: 'nl-nl',
    name: 'Nederlands',
  },
  {
    code: 'en-gb',
    name: 'English',
  },
  {
    code: 'fr-fr',
    name: 'Français',
  },
  {
    code: 'de-de',
    name: 'Deutsch',
  },
  {
    code: 'it-it',
    name: 'Italiano',
  },
  {
    code: 'es-es',
    name: 'Español',
  },
  {
    code: 'nb-no',
    name: 'Norsk',
  },
  {
    code: 'da-dk',
    name: 'Dansk',
  },
  {
    code: 'sv-se',
    name: 'Svenska',
  },
  {
    code: 'fi-fi',
    name: 'Suomi',
  },
];

export const LanguageNamesProvider: {
  provide: string;
  useValue: LanguageNames;
} = {
  provide: 'languageNames',
  useValue: languageNames,
};
